import { fork } from 'redux-saga/effects'

import GeneralGetSaga from './GeneralGetSaga'
import GeneralPostSaga from './GeneralPostSaga'
import AuthorizationSaga from './AuthorizationSaga'
import LocalStorageSaga from './LocalStorageSaga'

export default function* RootSaga() {
  yield fork(GeneralGetSaga)
  yield fork(GeneralPostSaga)
  yield fork(AuthorizationSaga)
  yield fork(LocalStorageSaga)

  }